import { render, staticRenderFns } from "./ygmessage.vue?vue&type=template&id=315b0f59&scoped=true"
import script from "./ygmessage.vue?vue&type=script&lang=js"
export * from "./ygmessage.vue?vue&type=script&lang=js"
import style0 from "./ygmessage.vue?vue&type=style&index=0&id=315b0f59&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315b0f59",
  null
  
)

export default component.exports